import Checkbox from '@mui/material/Checkbox'
import './checkboxStyles.css'

const CheckboxInput = (props) => {
    return (
        <Checkbox
            id={props.id}
            size='medium'
            checked={props.checked}
            onChange={props.onChange}
            disableRipple
            indeterminate={props.indeterminate}
        />
    )
}

export default CheckboxInput